import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { deleteCart } from '@/data/api/request/cartRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteCart() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  return useMutation({
    mutationFn: (cartId: string) => deleteCart(cartId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.carts.list] });
      showSnackSuccess('Carrito borrado');
    },
    onError: () => showSnackError('Error al borrar carrito'),
  });
}
